import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { initialValuesPec } from 'shell/types/types-pec';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

const PagePecInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesPec}>
      <Outlet />
    </FilterTableProvider>
  );
};

PagePecInitializer.displayName = 'Page Management PEC initializer component';

export default PagePecInitializer;
